import React, { useState, useEffect } from 'react';
import PublisherApiService from '../../ApiServices/PublisherApiService/PublisherApiService';
import { useAuth } from '../Auth/AuthContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PublishersTable from '../Publishers/PublishersTable';
import PublisherDetails from '../Publishers/PublisherDetails';

const Publishers = () => {
    const [publishers, setPublishers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedPublisher, setSelectedPublisher] = useState(null);
    const { authState } = useAuth();

    const fetchPublishers = async () => {
        setLoading(true);
        try {
            const response = await PublisherApiService.get();
            setPublishers(response.data);
        } catch (error) {
            console.error('Failed to fetch publishers:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPublishers();
    }, []);

    const handleSearch = (value) => {
        setSearchTerm(value);
    };

    const filteredPublishers = searchTerm
        ? publishers.filter(publisher =>
            publisher.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            publisher.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
            publisher.company.toLowerCase().includes(searchTerm.toLowerCase()) ||
            publisher.phone.includes(searchTerm)
        )
        : publishers;


    const handleToggleInvoice = async (id, currentStatus) => {
        try {
            await PublisherApiService.updateInvoice(id);
            setPublishers(publishers.map(publisher =>
                publisher.id === id ? { ...publisher, isInvoiceEnable: !currentStatus } : publisher
            ));
            if (selectedPublisher?.id === id) {
                setSelectedPublisher(prev => ({
                    ...prev,
                    isInvoiceEnable: !currentStatus
                }));
            }
        } catch (error) {
            console.error('Failed to update invoice status:', error);
        }
    };

    const handleApprovePublisher = async (id) => {
        try {
            await PublisherApiService.ApprovePublisher(id);
            fetchPublishers();
        } catch (error) {
            console.error('Failed to approve publisher:', error);
        }
    };

    const handleDeletePublisher = async (id) => {
        try {
            await PublisherApiService.DeletePublisher(id);
            setPublishers(publishers.filter(publisher => publisher.id !== id));
            if (selectedPublisher?.id === id) {
                setSelectedPublisher(null);
            }
        } catch (error) {
            console.error('Failed to delete publisher:', error);
        }
    };

    return (
        <div className="p-6 bg-gray-50 min-h-screen">
            <ToastContainer position="top-right" autoClose={3000} />

            <PublishersTable
                publishers={filteredPublishers}
                loading={loading}
                searchTerm={searchTerm}
                onSearch={handleSearch}
                onToggleInvoice={handleToggleInvoice}
                onApprovePublisher={handleApprovePublisher}
                onDeletePublisher={handleDeletePublisher}
                onSelectPublisher={setSelectedPublisher}
                isAdmin={authState.roles === "Admin"}
            />

            {selectedPublisher && (
                <PublisherDetails
                    publisher={selectedPublisher}
                    onToggleInvoice={handleToggleInvoice}
                    onClose={() => setSelectedPublisher(null)}
                />
            )}
        </div>
    );
};

export default Publishers;